import {
  ProjectKeysContainer,
  TaskTitle,
  TaskDescription,
} from './ProjectKeysStyles';

export const ProFirestoreSplash = () => {
  return (
    <ProjectKeysContainer>
      <TaskTitle>Manage Your Database - Coming Soon!</TaskTitle>
      <TaskDescription>
        This feature is not available yet. Please come back soon!
      </TaskDescription>
    </ProjectKeysContainer>
  );
};
